module.exports = __webpack_public_path__ + "static/img/avatar-dt.dd65a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-dt.jpg
// module id = opc2
// module chunks = 52